<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Payment Gateway</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card p-mt-4">
                <DataTable :value="clientRoles" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="ad1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Payment Gateway" icon="pi pi-plus" @click="toAddRoles" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column field="id" header="Sr." headerStyle="width: 10%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Payment Type" field="hl3" class="p-text-capitalize" headerStyle="width: 35%"
                        style="overflow-wrap: break-word">
                    </Column>
                    <Column header="App Id" field="hl4" headerStyle="width: 35%" style="overflow-wrap: break-word">
                    </Column>
                    <Column header="Api key" field="hl5" headerStyle="width: 35%" style="overflow-wrap: break-word">
                    </Column>
                    <Column header="Status" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <span v-if="data.hl7 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.hl7 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 20%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editEmployeeRoleModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddPeyment" :style="{ width: '900px' }" :modal="true" class="p-fluid"
        header="Add Payment Gateway">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="getway">
                            Peyment Geteway Type
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="roleName" class="p-text-capitalize" v-model="getway" :options="getwayList"
                            optionLabel="label" required="true" :class="{ 'p-invalid': isSubmitted && !roleName }"
                            placeholder="Select geteway type" emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.getway.$error">{{
                            v$.getway.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="apikey">
                            Api key
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="apikey" v-model="apikey" required="true" maxlength="100"
                            placeholder="Enter api key" :class="{ 'p-invalid': isSubmitted && !apikey }" />
                        <small class="p-invalid p-error" v-if="v$.apikey.$error">{{
                            v$.apikey.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="secreatkey">
                            Secreat Key
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="secreatkey" v-model="secreatkey" required="true" maxlength="100"
                            placeholder="Enter secreat key" :class="{ 'p-invalid': isSubmitted && !secreatkey }" />
                        <small class="p-invalid p-error" v-if="v$.secreatkey.$error">{{
                            v$.secreatkey.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            App ID
                        </label>
                        <InputText id="appid" v-model="appid" required="true" maxlength="100" placeholder="Enter app id"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            First Split Payment Account
                        </label>
                        <InputText id="appid" v-model="splitePeymentOne" required="true" maxlength="100" placeholder="Enter split payment one"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Second Split Payment Account
                        </label>
                        <InputText id="appid" v-model="splitePeymentTwo" required="true" maxlength="100" placeholder="Enter split payment two"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Order Id URL
                        </label>
                        <InputText id="appid" v-model="orderIdUrl" required="true" maxlength="100" placeholder="Enter order id url"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Dashboard URL
                        </label>
                        <InputText id="appid" v-model="dashboardUrl" required="true" maxlength="100" placeholder="Enter dashboard url"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">Payment Gateway Status</label>
                        <Dropdown id="adminstatus" v-model="paymentStatus" :options="paymentStatusList" optionLabel="label"
                            placeholder="Select geteway status" appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addPeymentgetway" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px"></Button> -->
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditEmployeeRole" header="Edit Payment Gateway" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="getway">
                            Peyment Geteway Type
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="roleName" class="p-text-capitalize" v-model="getway" :options="getwayList"
                            optionLabel="label" required="true" :class="{ 'p-invalid': isSubmitted && !roleName }"
                            placeholder="Select geteway type" emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.getway.$error">{{
                            v$.getway.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="apikey">
                            Api key
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="apikey" v-model="apikey" required="true" maxlength="100"
                            placeholder="Enter api key" :class="{ 'p-invalid': isSubmitted && !apikey }" />
                        <small class="p-invalid p-error" v-if="v$.apikey.$error">{{
                            v$.apikey.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="secreatkey">
                            Secreat Key
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="secreatkey" v-model="secreatkey" required="true" maxlength="100"
                            placeholder="Enter secreat key" :class="{ 'p-invalid': isSubmitted && !secreatkey }" />
                        <small class="p-invalid p-error" v-if="v$.secreatkey.$error">{{
                            v$.secreatkey.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            App ID
                        </label>
                        <InputText id="appid" v-model="appid" required="true" maxlength="100" placeholder="Enter app id"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                        <!-- <small class="p-invalid p-error" v-if="v$.appid.$error">{{
                            v$.appid.$errors[0].$message
                            }}</small> -->
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            First Split Payment Account
                        </label>
                        <InputText id="appid" v-model="splitePeymentOne" required="true" maxlength="100" placeholder="Enter split payment one"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Second Split Payment Account
                        </label>
                        <InputText id="appid" v-model="splitePeymentTwo" required="true" maxlength="100" placeholder="Enter split payment two"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Order Id URL
                        </label>
                        <InputText id="appid" v-model="orderIdUrl" required="true" maxlength="100" placeholder="Enter order id url"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">
                            Dashboard URL
                        </label>
                        <InputText id="appid" v-model="dashboardUrl" required="true" maxlength="100" placeholder="Enter dashboard url"
                            :class="{ 'p-invalid': isSubmitted && !appid }" />
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="appid">Payment Gateway Status</label>
                        <Dropdown id="adminstatus" v-model="paymentStatus" :options="paymentStatusList" optionLabel="label"
                            placeholder="Select geteway status" appendTo="body">
                        </Dropdown>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body">
                        </Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editEmployeeRole" style="width: 90px;"></Button>
            <!-- <Button v-show="showLoaderAddBtn" icon="pi pi-spin pi-spinner indigo-color" class="p-button-text p-ml-auto"
                style="width: 90px" appendTo="body"></Button> -->
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';

export default {
    data() {
        return {
            clientRoles: [],
            v$: useValidate(),
            isAddPeyment: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            getwayList: [{
                label: 'Cash Free',
                value: '1',
            }, {
                label: 'Razor Pay',
                value: '2',
            }, {
                label: 'Easebuzz',
                value: '3',
            }, {
                label: 'SBTcashfree',
                value: '4',
            }
            ],
            isEditEmployeeRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            UserIdList: [],
            localAdminName: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            paymentStatusList: [
                { label: 'Production', value: 1 },
                { label: 'Testing', value: 2 },
            ],
            getway: '',
            apikey: '',
            secreatkey: '',
            appid: '',
            errormsg: '',
            paymentStatus: { label: 'Production', value: 1 },
            splitePeymentOne: '',
            splitePeymentTwo: '',
            orderIdUrl: '',
            dashboardUrl: '',
            routeParam: '',
        };
    },
    validations() {
        return {
            getway: { required: helpers.withMessage('Please select peyment geteway type', required) },
            apikey: { required: helpers.withMessage('Please enter app key', required) },
            secreatkey: { required: helpers.withMessage('Please enter secreat key', required) },
            // appid: { required: helpers.withMessage('Please enter app id', required) },
        };
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    computed: {
        callStatusFlag() {
            return this.$store.getters.getCallStatusFlag;
        }
    },
    async mounted() {
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.loading = true;
        this.getPaymentGatwayDetails({ maa1: this.routeParam });
    },
    methods: {
        async toAddRoles() {
            this.isAddPeyment = true;
            this.isSubmitted = false;
            this.getway = ''
            this.apikey = '';
            this.secreatkey = '';
            this.appid = '';
            this.showLoader = false;
            this.errormsg = '';
            this.splitePeymentOne = '';
            this.splitePeymentTwo = '';
            this.orderIdUrl = '';
            this.dashboardUrl = '';
            this.paymentStatus = { label: 'Production', value: 1 };
            this.v$.$reset();
        },
        addPeymentgetway() {
            this.submitted = true;
            this.errormsg = '';
            let fields = {};
            fields['maa1'] = this.routeParam;
            fields['hl2'] = this.getway.value;
            fields['hl3'] = this.getway.label;
            fields['hl4'] = this.appid;
            fields['hl5'] = this.apikey;
            fields['hl6'] = this.secreatkey;
            fields['hl7'] = 1;
            fields['hl9'] = this.splitePeymentOne;
            fields['hl10'] = this.splitePeymentTwo;
            fields['hl11'] = this.orderIdUrl;
            fields['hl12'] = this.dashboardUrl;
            fields['hl13'] = this.paymentStatus.value;
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdategetPaymentGatwayDetails(fields).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getPaymentGatwayDetails({ maa1: this.routeParam });
                        this.isAddPeyment = false;
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editEmployeeRoleModalOpen(data) {
            this.isEditEmployeeRole = true;
            this.paymentStatus = ''
            this.splitePeymentOne = ''
            this.splitePeymentTwo = ''
            this.orderIdUrl = ''
            this.dashboardUrl = ''
            this.isEditEmployeeRole = true;
            this.rowId = data.hl1;
            this.getway = this.getwayList.find((item) => item.value == data.hl2);
            this.appid = data.hl4;
            this.apikey = data.hl5;
            this.secreatkey = data.hl6;
            this.adminstatus = {
                label: data.hl7 == 1 ? 'Active' : 'Inactive',
                value: data.hl7,
            };
            this.paymentStatus = this.paymentStatusList.find((item) => item.value == data.hl13);
            this.splitePeymentOne = data.hl9;
            this.splitePeymentTwo = data.hl10;
            this.orderIdUrl = data.hl11;
            this.dashboardUrl = data.hl12;
        },
        editEmployeeRole() {
            this.submitted = true;
            this.errormsg = '';
            let fields = {};
            fields['maa1'] = this.routeParam;
            fields['hl1'] = this.rowId;
            fields['hl2'] = this.getway.value;
            fields['hl3'] = this.getway.label;
            fields['hl4'] = this.appid;
            fields['hl5'] = this.apikey;
            fields['hl6'] = this.secreatkey;
            fields['hl7'] = this.adminstatus.value;
            fields['hl9'] = this.splitePeymentOne;
            fields['hl10'] = this.splitePeymentTwo;
            fields['hl11'] = this.orderIdUrl;
            fields['hl12'] = this.dashboardUrl;
            fields['hl13'] = this.paymentStatus?.value ;
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdategetPaymentGatwayDetails(fields).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getPaymentGatwayDetails({ maa1: this.routeParam });
                        this.isEditEmployeeRole = false;
                        this.employee = '';
                        this.roleName = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        async getPaymentGatwayDetails(payload) {
            try {
                const result = await this.ApiService.getPaymentGatwayDetails(payload);
                if (result.status == 201) {
                    this.$toast.add({
                        severity: 'error',
                        summary: 'Error', detail: result.message, life: 3000
                    });
                } else {
                    this.clientRoles = result.data;
                    this.totalRecords = result.data.count;
                    this.UserIdList = result.data.ad1Values;
                }
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error.message, life: 3000 });
            } finally {
                this.loading = false;
            }
        },

        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getPaymentGatwayDetails({ page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "notification",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "AppPopupSettings",
                params: { adminSubId: this.routeParam },
            });
        }
    }

};
</script>

<style scoped></style>
